import { backendApiGateway } from '~/client/backend';
import { Document } from '~/types/document';
import { ItalianEInvoice } from '~/types/invoicing';

export const getEInvoice = async (documentId: Document['id']): Promise<ItalianEInvoice> => {
  const { data } = await backendApiGateway.get<{ data: ItalianEInvoice }>(`/api/v1/documents/${documentId}/einvoice`);
  return data.data;
};
